import { UtilityService } from '../../../infrastructure/services/utils';
import { AnalyticsModel } from './AnalyticsModel';
import { AnalyticsConstants } from './constants';
import { AnalyticsActions } from './IAnalyticsTasks';
import { IResultClick } from './IResultClick';

/**
 * create model for analytics api payload
 * @param   {object} data api payload data
 * @param   {sting} idToken authentication token
 */
export class ResultClickModel extends AnalyticsModel {
  constructor(data: IResultClick) {
    const paxContextGuid = UtilityService.generateGuid();
    super(data, paxContextGuid);

    const isSemantic = data.Query && data?.Query.trim().split(/\s+/).length >= 4 ? "semanticsearch" : "keywordsearch"
    const site = window.location.origin
      ? `${window.location.origin}#${isSemantic}`
      : null;
    if (this.analyticsData.eventData) {
      this.analyticsData.document = [
        {
          ...this.analyticsData.eventData,          
          Query: data.Query ? data.Query : '',
          Issues: [AnalyticsConstants.NoIssues],
          SearchURL: window.location.href ? window.location.href : null,
          Page: data.Page ? data.Page : '1',
          Document: data.Document ? data.Document : null,
          Position: data.Position ? data.Position : 0,
          PageURL: (window.location.origin + '/#' + data.PageURL) ? window.location.origin + '/#' + data.PageURL : null,
          ActionsSequence: data.ActionsSequence ? data.ActionsSequence : {},
          Action: AnalyticsActions.resultItem,
          Title: data.Title ? UtilityService.removeHtmlTags(data.Title) : null,
          Vertical: data.Vertical ? data.Vertical : '',
          WasSuggested: data.WasSuggested
            ? data.WasSuggested
            : AnalyticsConstants.falseString,
          WasRecentSearch: data.WasRecentSearch
            ? data.WasRecentSearch
            : AnalyticsConstants.falseString,
            ...(data.ItemClickType !== '' ? { ItemClickType: data.ItemClickType } :{ItemClickType:null} ),
            Site: site
        }
      ];
      delete this.analyticsData.eventData;
    }
  }
}
